/**
 * O'CHIQ amalning sababi — YORLIQNING O'ZIDA.
 *
 * <h2>⚠️ Nega tooltip emas</h2>
 * antd menyu bandi `disabled` bo'lganda ustidagi ko'rsatkich
 * hodisalarini qabul qilmaydi, ya'ni tooltip aynan KERAK bo'lgan
 * holatda ochilmaydi. "Sabab bor, lekin ko'rinmaydi" — bu sababsizlik
 * bilan bir xil: operator bandni bosib ko'radi, hech narsa bo'lmaydi
 * va u xulosa qila olmaydi.
 *
 * <h2>⚠️ Nega amal umuman yashirilmaydi</h2>
 * Yashirilgan amal "bunday imkoniyat yo'q" deb o'qiladi. Yopilgan lid
 * yoki niqoblangan telefon esa VAQTINCHALIK to'siq — operator uni
 * ochishi (yoki boshqa yozuvda ishlashi) mumkin, faqat buni bilishi
 * kerak.
 */
export function actionReason(label: string, reason: string | null): string {
  return reason === null ? label : `${label} — ${reason}`
}
